import React from "react";

interface LoadingProps {
  size?: "sm" | "md" | "lg";
  fullScreen?: boolean;
}

const sizeClasses = {
  sm: "h-4 w-4 border-2",
  md: "h-6 w-6 border-4",
  lg: "h-8 w-8 border-4",
};

const Loading: React.FC<LoadingProps> = ({ size = "md", fullScreen = false }) => {
  const spinner = (
    <div
      className={`animate-spin rounded-full border-t-transparent border-gray-400 border-solid ${sizeClasses[size]}`}
      style={{ borderRadius: "50%" }}
    />
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default Loading;